<div *ngIf="serialsData as serials else loading">

  <div class="mb-3 flex gap-2 align-items-center">
    <p-selectButton [options]="statusOptions"
                    [(ngModel)]="selectedStatus"
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="onStatusFilterChange($event)"
                    pTooltip="Filter by serial status"
                    tooltipPosition="top">
    </p-selectButton>

    <p-button icon="pi pi-refresh"
              (onClick)="onRefresh()"
              styleClass="p-button-rounded p-button-text"
              pTooltip="Refresh serials"
              tooltipPosition="top">
    </p-button>
  </div>

  <p-table #serialsTable
           [value]="serials"
           [loading]="isLoading"
           [rows]="25"
           [rowsPerPageOptions]="[10,25,50,100]"
           [showCurrentPageReport]="true"
           [paginator]="true"
           paginatorPosition="both"
           currentPageReportTemplate="Showing {first} to {last} of {totalRecords} serials"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           [filterDelay]="300"
           dataKey="SerialNumber"
           [resizableColumns]="true"
           columnResizeMode="fit"
           [tableStyle]="{ 'min-width': '100rem' }">

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn pSortableColumn="SerialNumber" style="width: 15% !important">Serial Number <p-sortIcon field="SerialNumber"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="IncomeSpecDate" style="width: 10% !important">Income Date <p-sortIcon field="IncomeSpecDate"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="IncomeOrderDocNumber" style="width: 12rem !important">Income Order <p-sortIcon field="IncomeOrderDocNumber"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="IncomeSpecDocNumber" style="width: 12rem !important">Income Spec <p-sortIcon field="IncomeSpecDocNumber"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="OutcomeSpecDate" style="width: 10% !important">Outcome Date <p-sortIcon field="OutcomeSpecDate"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="OutcomeOrderDocNumber" style="width: 12rem !important">Outcome Order <p-sortIcon field="OutcomeOrderDocNumber"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="OutcomeSpecDocNumber" style="width: 12rem !important">Outcome Spec <p-sortIcon field="OutcomeSpecDocNumber"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="InvoiceDocNumber" style="width: 10rem !important">Invoice <p-sortIcon field="InvoiceDocNumber"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="SerialStatus" style="width: 12rem !important">Status <p-sortIcon field="SerialStatus"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="IsManufacturingConsumption" style="width: 8rem !important">Manufacturing <p-sortIcon field="IsManufacturingConsumption"></p-sortIcon></th>
      </tr>
      <tr>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'SerialNumber', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="serialNumberFilter"
                 class="p-column-filter" [class.hasvalue]="serialNumberFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'IncomeSpecDate', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="incomeSpecFilter"
                 class="p-column-filter" [class.hasvalue]="incomeSpecFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'IncomeOrderDocNumber', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="incomeOrderFilter"
                 class="p-column-filter" [class.hasvalue]="incomeOrderFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'IncomeSpecDocNumber', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="incomeSpecFilter"
                 class="p-column-filter" [class.hasvalue]="incomeSpecFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'OutcomeSpecDate', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="outcomeSpecDateFilter"
                 class="p-column-filter" [class.hasvalue]="outcomeSpecDateFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'OutcomeOrderDocNumber', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="outcomeOrderFilter"
                 class="p-column-filter" [class.hasvalue]="outcomeOrderFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'OutcomeSpecDocNumber', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="outcomeSpecFilter"
                 class="p-column-filter" [class.hasvalue]="outcomeSpecFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'InvoiceDocNumber', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="invoiceFilter"
                 class="p-column-filter" [class.hasvalue]="invoiceFilter">
        </th>
        <th pResizableColumn style="overflow: visible !important;">
          <input pInputText type="text"
                 (input)="serialsTable.filter($event.target.value, 'SerialStatus', 'contains')"
                 placeholder="Search"
                 [(ngModel)]="statusFilter"
                 class="p-column-filter" [class.hasvalue]="statusFilter">
        </th>
        <th pResizableColumn></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-serial>
      <tr>
        <td>{{serial.SerialNumber}}</td>
        <td>{{formatDate(serial.IncomeSpecDate)}}</td>
        <td>
          <a *ngIf="serial.IncomeOrderDocId; else incomeOrderEmpty"
             [routerLink]="['/edit-document', serial.IncomeOrderDocType, serial.IncomeOrderDocId]">
            {{serial.IncomeOrderDocNumber}}
          </a>
          <ng-template #incomeOrderEmpty>
            <span class="text-500">—</span>
          </ng-template>
        </td>
        <td>
          <a *ngIf="serial.IncomeSpecDocId; else incomeSpecEmpty"
             [routerLink]="['/edit-document', serial.IncomeSpecDocType, serial.IncomeSpecDocId]">
            {{serial.IncomeSpecDocNumber}}
          </a>
          <ng-template #incomeSpecEmpty>
            <span class="text-500">—</span>
          </ng-template>
        </td>
        <td>{{formatDate(serial.OutcomeSpecDate)}}</td>
        <td>
          <a *ngIf="serial.OutcomeOrderDocId; else outcomeOrderEmpty"
             [routerLink]="['/edit-document', serial.OutcomeOrderDocType, serial.OutcomeOrderDocId]">
            {{serial.OutcomeOrderDocNumber}}
          </a>
          <ng-template #outcomeOrderEmpty>
            <span class="text-500">—</span>
          </ng-template>
        </td>
        <td>
          <a *ngIf="serial.OutcomeSpecDocId; else outcomeSpecEmpty"
             [routerLink]="['/edit-document', serial.OutcomeSpecDocType, serial.OutcomeSpecDocId]">
            {{serial.OutcomeSpecDocNumber}}
          </a>
          <ng-template #outcomeSpecEmpty>
            <span class="text-500">—</span>
          </ng-template>
        </td>
        <td>
          <a *ngIf="serial.InvoiceDocId; else invoiceEmpty"
             [routerLink]="['/edit-document', serial.InvoiceDocType, serial.InvoiceDocId]">
            {{serial.InvoiceDocNumber}}
          </a>
          <ng-template #invoiceEmpty>
            <span class="text-500">—</span>
          </ng-template>
        </td>
        <td>
          <p-tag [value]="getStatusLabel(serial.SerialStatus)"
                 [severity]="getStatusBadgeSeverity(serial.SerialStatus)">
          </p-tag>
        </td>
        <td style="text-align: center">
          <p-tag *ngIf="serial.IsManufacturingConsumption === 1"
                 value="Yes"
                 severity="warning">
          </p-tag>
          <span *ngIf="serial.IsManufacturingConsumption === 0" class="text-500">—</span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10">No serials found</td>
      </tr>
    </ng-template>
  </p-table>

</div>

<ng-template #loading>
  <div class="flex justify-content-center p-4">
    <p-progressSpinner [style]="{'width':'40px','height':'40px'}"></p-progressSpinner>
  </div>
</ng-template>
